import { API } from "@/services"

export const CALLSTATS_ENDPOINTS = {
  servers(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `callstats/servers`,
      method: 'GET',
      params,
    })
  },
  chart(params={},extra={}){
    return API.Axios.callstats.v1.request({
      ...extra,
      url: `callstats/chart`,
      method: 'GET',
      params,
    })
  },
}